import type { RenderAssetPricingSummary } from '@/lib/api-types'

export type AssetStorefrontMode = 'money' | 'coin' | 'hidden'
export type AssetStorefrontSummaryMode = AssetStorefrontMode | 'mixed' | 'unconfigured'

export function normalizeAssetStorefrontMode(value?: string | null): AssetStorefrontMode {
	switch ((value ?? '').trim().toLowerCase()) {
		case 'coin':
		case 'coins':
			return 'coin'
		case 'hidden':
		case 'hide':
			return 'hidden'
		default:
			return 'money'
	}
}

export function getAssetStorefrontLabel(value: AssetStorefrontSummaryMode): string {
	switch (value) {
		case 'coin':
			return 'Cửa hàng coin'
		case 'hidden':
			return 'Ẩn khỏi cửa hàng'
		case 'mixed':
			return 'Nhiều loại'
		case 'unconfigured':
			return 'Chưa cấu hình'
		default:
			return 'Cửa hàng tiền ingame'
	}
}

export function getAssetStorefrontToneClass(value: AssetStorefrontSummaryMode): string {
	switch (value) {
		case 'coin':
			return 'border-sky-500/30 bg-sky-500/10 text-sky-700'
		case 'hidden':
			return 'border-slate-500/30 bg-slate-500/10 text-slate-700'
		case 'mixed':
			return 'border-fuchsia-500/30 bg-fuchsia-500/10 text-fuchsia-700'
		case 'unconfigured':
			return 'border-border bg-muted text-muted-foreground'
		default:
			return 'border-emerald-500/30 bg-emerald-500/10 text-emerald-700'
	}
}

export function resolveAssetStorefrontSummaryMode(summary?: RenderAssetPricingSummary): AssetStorefrontSummaryMode {
	if (!summary || summary.linkedTextureCount <= 0) {
		return 'unconfigured'
	}
	if (summary.uniformPriceType) {
		return normalizeAssetStorefrontMode(summary.uniformPriceType)
	}
	if (summary.defaultPriceType) {
		return 'mixed'
	}
	return 'money'
}
